export const ALLBINDERS = "ALLBINDERS";
export const WIP = "WIP";
export const ARCHIVE = "ARCHIVE";
export const VAULT = "VAULT";
export const CLEAR = "CLEAR";
